import { render } from "./PaymentFailPage.vue?vue&type=template&id=578f7c08&scoped=true"
import script from "./PaymentFailPage.vue?vue&type=script&lang=js"
export * from "./PaymentFailPage.vue?vue&type=script&lang=js"

import "./PaymentFailPage.vue?vue&type=style&index=0&id=578f7c08&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578f7c08"]])

export default __exports__